import { createFormContext } from '@mantine/form'
import type { Gender, PromptStyle } from 'src/services/helpers/preference'

export interface NewUserOnboardingForm {
  gender?: Gender
  otherGenderName?: string
  username?: string
  promptStyle?: PromptStyle
  categories?: string[]
  characters?: string[]
}
export const [
  NewUserOnboardingFormProvider,
  useNewUserOnboardingFormContext,
  useNewUserOnboardingForm,
] = createFormContext<NewUserOnboardingForm>()
